<template>
	<component v-if="loadedComponent" :is="loadedComponent" :ref="setChildrenRefs" v-bind="$attrs" v-on="$listeners">
		<!-- 具名插槽 PS:vue2不支持 slots 动态渲染 -->
		<template v-for="slotName in supportedSlotNames" v-slot:[slotName]="slotProps">
			<slot :name="slotName" v-bind="slotProps ?? {}" />
		</template>
		<!-- 默认插槽 -->
		<template v-slot:default="slotProps">
			<slot v-bind="slotProps ?? {}" />
		</template>
	</component>
</template>

<script>
export default {
	name: 'SmartLayoutComponent',
	inheritAttrs: false
};
</script>

<script setup>
import { shallowRef, ref, onMounted, watch } from 'vue';
import { useComponentResolver } from '@rebuild/hooks/comp/useComponentResolver.js';

const props = defineProps({
	compId: {
		type: String,
		default: ''
	},
	mode: {
		type: String,
		default: ''
	}
});

const { resolveComponent, supportedSlotNames } = useComponentResolver('layout');
const loadedComponent = shallowRef(null);
const reloadComponent = () => {
	const result = resolveComponent(props.compId, props.mode);
	if (result?.component) {
		loadedComponent.value = result.component;
	}
};

onMounted(() => {
	reloadComponent();
});
watch(
	() => props.mode,
	() => reloadComponent()
);

const childrenRefs = ref(null);
const setChildrenRefs = el => {
	childrenRefs.value = el;
};
defineExpose({
	get child() {
		return childrenRefs.value;
	}
});
</script>
